import React, { HTMLAttributes } from 'react';

type Props = HTMLAttributes<SVGElement>;

export const TopBlob = ({ ...all }: Props) => (
  <svg
    width='1411'
    height='1321'
    viewBox='0 0 1411 1321'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...all}
  >
    <path
      d='M784.609 218.042C906.008 195.46 1066.88 223.43 1158.45 322.882C1250.02 422.333 1272.7 593.917 1223.18 729.397C1173.01 865.291 1050.65 965.082 932.259 986.661C814.514 1007.83 699.676 950.547 563.749 933.137C427.823 915.728 270.394 937.541 180.081 870.117C88.7055 802.457 65.7421 644.734 129.787 549.245C193.833 453.756 344.887 420.5 462.438 367.542C579.575 313.935 663.209 240.624 784.609 218.042Z'
      fill='#F2F4F8'
      fillOpacity='0.01'
    />
  </svg>
);
